import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { TicketService } from 'src/app/Services/ticket/ticket.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-group-ticket-details',
  templateUrl: './group-ticket-details.component.html',
  styleUrls: ['./group-ticket-details.component.css']
})
export class GroupTicketDetailsComponent implements OnInit {

  @ViewChild('fileUploader' ,{static: false}) fileUploader:ElementRef;
  TicketStatusID:any;
  PrintModel={
    TicketID:0,
  }
  constructor(private ticketservice: TicketService,private spinnerService: Ng4LoadingSpinnerService, 
    public globalHelper: GlobalHelper) {
   
  }

  TicketDetailsList=[];
  TicketMessageList=[];
  AttachmentList=[];
  GetTicketDetails() {
    this.spinnerService.show();
    this.ticketservice.GetGroupAdminTicketDetails(JSON.stringify(this.PrintModel)).subscribe((response: any) => {
      this.TicketDetailsList = response.TicketDetailsList;
      this.TicketMessageList = response.TicketMessageList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
    });
  };

  MessageModel={
    Message:'',    
  }
 
  AllAttachment:string[] = []; 
  getFileDetails(e) {
    this.AllAttachment = [];
    for (var i = 0; i < e.target.files.length; i++) {    
     this.AllAttachment.push(e.target.files[i])      
    }
 }
   
  ValidSave() {
    return this.PrintModel.TicketID == 0;
  }

  Submitted = false;
  SendReplyTicket(valid) {
    this.Submitted = true;
    if (valid && !this.ValidSave()) {
      this.spinnerService.show();
      this.Submitted = false;
      this.ticketservice.SendGroupAdminReplyTicket(JSON.stringify(this.PrintModel),this.AllAttachment,this.MessageModel.Message).subscribe((response: any) => {
        this.spinnerService.hide();        
        this.globalHelper.CheckActionStatus(response);
        if(response.webResponse.Status){
          this.MessageModel.Message='';
          this.fileUploader.nativeElement.value = null;
          this.GetTicketDetails();
        }
      });
    }
  };



  ngOnInit() {
    this.PrintModel.TicketID = window.history.state.TicketID;
    this.GetTicketDetails();
  }

}
